interface RecentlyViewedClient {
  id: string;
  name: string;
  phone: string;
  type: 'Adult' | 'Minor' | 'Couple';
  viewedAt: Date;
}

class RecentlyViewedService {
  private static instance: RecentlyViewedService;
  private readonly STORAGE_KEY = 'recentlyViewedClients';
  private readonly MAX_ITEMS = 5;

  private constructor() {}

  static getInstance(): RecentlyViewedService {
    if (!RecentlyViewedService.instance) {
      RecentlyViewedService.instance = new RecentlyViewedService();
    }
    return RecentlyViewedService.instance;
  }

  // Add a client to recently viewed
  addClient(client: Omit<RecentlyViewedClient, 'viewedAt'>): void {
    const clients = this.getClients();

    // Remove if already exists
    const filtered = clients.filter(c => c.id !== client.id);

    // Add to beginning
    const updated: RecentlyViewedClient[] = [
      { ...client, viewedAt: new Date() },
      ...filtered
    ];

    // Keep only MAX_ITEMS
    const limited = updated.slice(0, this.MAX_ITEMS);

    this.saveClients(limited);
  }

  // Get all recently viewed clients
  getClients(): RecentlyViewedClient[] {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) return [];

      const parsed = JSON.parse(stored);
      // Convert date strings back to Date objects
      return parsed.map((c: any) => ({
        ...c,
        viewedAt: new Date(c.viewedAt)
      }));
    } catch (error) {
      console.error('Error loading recently viewed clients:', error);
      return [];
    }
  }

  // Clear all recently viewed
  clearAll(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  // Remove a specific client
  removeClient(clientId: string): void {
    const clients = this.getClients();
    const filtered = clients.filter(c => c.id !== clientId);
    this.saveClients(filtered);
  }

  private saveClients(clients: RecentlyViewedClient[]): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(clients));
    } catch (error) {
      console.error('Error saving recently viewed clients:', error);
    }
  }
}

export default RecentlyViewedService;
export type { RecentlyViewedClient };
